/**
 * A traversal strategy that performs a breadth-first search (so as to not load blocks unnecessarily) looking for a
 * target CID. Traversal stops when we reach the target CID or run out of nodes.
 */
export class GraphSearch {
    target;
    constructor(target) {
        this.target = target;
    }
    isTarget(cid) {
        return this.target.equals(cid);
    }
    async *traverse(cid, block) {
        for await (const [, linkedCid] of block.links()) {
            yield linkedCid;
        }
    }
}
//# sourceMappingURL=graph-search.js.map